export default "__VITE_ASSET__Ux98W61l__"